import { createFileRoute } from '@tanstack/react-router';
import { KlaviyoEntryShell, KlaviyoBrandPicker } from '@/components/settings/KlaviyoBrandPicker';

// Klaviyo's app listing links here for installs started from klaviyo.com.
// Brand-agnostic, so the user picks which nexmail brand to connect. Under
// _authed, whose sign-in redirect keeps the path, so a cold visit lands back
// here after login.
export const Route = createFileRoute('/_authed/integrations/klaviyo/install')({
  component: KlaviyoInstallPage,
});

function KlaviyoInstallPage() {
  return (
    <KlaviyoEntryShell>
      <KlaviyoBrandPicker mode="install" />
    </KlaviyoEntryShell>
  );
}
